<template>
    <div id="ReturnOrderRequest" style="min-width: 1200px;min-height: 95vh">
        <q-card style="min-height: 90vh;">

            <div class="row q-pa-md">
                <div class="col-12">
                    <div class="d-flex justify-content-between">
                        <h4 class="mt-0 mb-3 text-left" style="font-size: 26px; font-weight: 300">
                            Return Order Request
                        </h4>
                        <span class="d-block">
                                <q-btn @click="closeReturnOrderDialog" class="q-ml-auto" flat icon="close" round
                                       size="small"></q-btn>
                        </span>
                    </div>
                </div>
                <div class="q-pa-md" style="width: 30%">
                    <div>
                        <div class="my-4">
                            <q-select :disable="isPartnerDisable" :options="partners"
                                      @filter="searchPartners"
                                      @input="cleanObjects(selectedPartner,'selectedPartner')"
                                      class="searchBox p-2 my-3" clearable
                                      filled hint="Minimum one character to trigger search"
                                      label="Search Partner" map-options option-label="name" option-value="id"
                                      outlined use-input v-model="selectedPartner">
                                <template v-slot:no-option>
                                    <q-item>
                                        <q-item-section class="text-grey"> No results</q-item-section>
                                    </q-item>
                                </template>
                                <template v-slot:option="scope">
                                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                        <q-item-section>
                                            <q-item-label v-html="scope.opt.name"></q-item-label>
                                            <q-item-label caption>{{ scope.opt.mobile }}</q-item-label>
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label>{{ scope.opt.partnerCode }}</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </q-select>
                        </div>
                        <div v-if="returnOrderCount>=5" class="my-1">
                            <span style="color: red;">You have exceed your limit of returning orders.</span>
                        </div>
                        <div class="my-4">
                            <q-select :disable="!selectedPartner || returnOrderCount >= 5"
                                      :option-label="optionLabelPreferredDistributors"
                                      :options="preferredDistributors" @filter="searchPreferredDistributors"
                                      @input="cleanObjects(selectedPreferredDistributor,'selectedPreferredDistributor')"
                                      class="searchBox p-2 my-3" clearable filled
                                      hint="Minimum one character to trigger search"
                                      label="Search Preferred Distributor"
                                      map-options option-value="id" outlined use-input
                                      v-model="selectedPreferredDistributor">
                                <template v-slot:no-option>
                                    <q-item>
                                        <q-item-section class="text-grey"> No results</q-item-section>
                                    </q-item>
                                </template>
                                <template v-slot:option="scope">
                                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                        <q-item-section>
                                            <q-item-label v-html="scope.opt.PrefferedPartner.name"></q-item-label>
                                            <q-item-label caption>{{ scope.opt.PrefferedPartner.mobile }}</q-item-label>
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label>{{ scope.opt.PrefferedPartner.email }}</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </q-select>
                        </div>
                        <div class="my-4">
                            <q-select :disable="!selectedPreferredDistributor" :options="orders" @filter="searchOrders"
                                      @input="cleanObjects(selectedOrder,'selectedOrder')" class="searchBox p-2 my-3"
                                      clearable filled hint="Minimum one character to trigger search"
                                      label="Search Orders" map-options
                                      option-disable="disabled" option-label="orderNum"
                                      option-value="id" outlined use-input v-model="selectedOrder">
                                <template v-slot:no-option>
                                    <q-item>
                                        <q-item-section class="text-grey"> No results</q-item-section>
                                    </q-item>
                                </template>
                                <template v-slot:option="scope">
                                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                        <q-item-section>
                                            <q-item-label v-html="scope.opt.orderNum"></q-item-label>
                                            <q-item-label style="color: red" v-if="scope.opt.disabled">
                                                Order Creation exceed 60 days.
                                            </q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </q-select>
                        </div>
                        <div class="my-4">
                            <q-radio :disable="!selectedOrder || isWholeOrderDisable" :label="modeOfReturn[0].value"
                                     :val="modeOfReturn[0].value" color="blue-10"
                                     v-model="selectedModeOfReturn"></q-radio>
                            <q-radio :disable="!selectedOrder" :label="modeOfReturn[1].value"
                                     :val="modeOfReturn[1].value" color="blue-10"
                                     v-model="selectedModeOfReturn"></q-radio>
                            <p style="font-size: 12px;color: red" v-if="isWholeOrderDisable">Whole Order is Disable
                                Because Some of Order Items are Already Transferred</p>
                        </div>
                        <div class="my-4">
                            <q-input class="searchBox p-2 my-3" label="Invoice No."
                                     v-model="invoiceNumber"></q-input>
                        </div>
                        <div class="my-4">
                            <q-input class="searchBox p-2 my-3" filled label="Invoice Date"
                                     mask="##/##/####"
                                     v-model="invoiceDateComp">
                                <template v-slot:append>
                                    <q-icon class="cursor-pointer " name="event">
                                        <q-popup-proxy ref="invoiceDate" transition-hide="scale"
                                                       transition-show="scale">
                                            <q-date @input="() => $refs.invoiceDate.hide()"
                                                    v-model="invoiceDate"/>
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>
                            </q-input>
                        </div>
                        <div class="my-4">
                            <q-input class="searchBox" label="Note/Remark" style="height: auto;" type="textarea"
                                     v-model="invoiceNote"></q-input>
                        </div>
                        <div class="my-4" v-if="selectedModeOfReturn==='Whole Order'">
                            <q-btn @click="onReturnOrder">PLACE ORDER</q-btn>
                        </div>
                    </div>
                </div>
                <div style="width: 70%;" v-if="selectedModeOfReturn==='Partial Order'">
                    <div style="width: 100%">
                        <div class="d-flex px-3">
                            <div class="w-100">
                                <q-input @input="searchBatch" class="mb-3 searchBox p-2 w-100"
                                         clearable fill-input label="Search by batch no. to return" outlined
                                         style="width: 41.66%" use-input
                                         v-model="searchBatchObj">
                                </q-input>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between q-pa-md">
                        <div style="width: 49%">
                            <div class="sectionOne position-relative">
                                <div class="st-header">
                                    <div style="margin-top: 5px;">
                                        <!--                                        <q-checkbox label="Select All" v-model="selectAll"></q-checkbox>-->
                                        <div class="mr-2 float-right">
                                            <q-btn @click="addToCart" class="pd-btn">add</q-btn>
                                        </div>
                                    </div>
                                </div>

                                <div class="overflow-hidden st-box w-100"
                                     style="min-height: 400px !important; margin-top: 45px;">
                                    <hr class="mb-3" style="border: 0.5px solid lightgray;">
                                    <div :key="index" class="mt-3 py-3 section-list"
                                         v-for="(orderItem,index) in orderItems">
                                        <q-checkbox :disable="checkDisableBatch(orderItem).isDisabled" :val="orderItem"
                                                    v-model="groupOneSelection">
                                            <div>
                                                <span style="font-size: 16px; font-weight: 500;">{{orderItem.Batch?orderItem.Batch.batch:'-' }}</span>
                                            </div>
                                            <div>
                                                <span style="font-size: 14px; color: #878787">{{ orderItem.Batch&&orderItem.Batch.Product?orderItem.Batch.Product.name:'-'}}</span>
                                            </div>
                                            <div v-if="checkDisableBatch(orderItem).isDisabled">
                                                <span style="font-size: 12px;color: red"> {{checkDisableBatch(orderItem).message}}</span>
                                            </div>
                                        </q-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 49%;">
                            <div class="sectionOne">
                                <div class="st-header">
                                    <div class=" d-flex justify-content-between"
                                         style="align-items: center; margin-top: 5px;">
                                        <p style="margin-top: 9px; margin-bottom: 9px; margin-left: 10px;">
                                            {{groupTwoSelection.length}} Selected</p>
                                        <div class="q-ml-auto" style="margin-bottom: 3px;"
                                             v-if="groupTwoSelection.length">
                                            <q-btn @click="onReturnOrder" class="q-ml-auto mr-2" color="primary"
                                                   style="font-weight: 300" v-if="groupTwoSelection.length">
                                                Return Order
                                            </q-btn>
                                        </div>
                                    </div>
                                </div>

                                <hr class="mb-3 " style="border: 0.5px solid lightgray;  margin-top: 45px;">
                                <div :key="index"
                                     class=" w-100 mt-3 py-3 section-list d-flex justify-content-between"
                                     style="cursor: pointer; padding-left: 10px; padding-right: 5px;"
                                     v-for="(orderItem,index) in groupTwoSelection">
                                    <div>
                                        <div>
                                            <span style="font-size: 16px; font-weight: 500;">{{orderItem.Batch?orderItem.Batch.batch:'-' }}</span>
                                        </div>
                                        <div>
                                            <span style="font-size: 14px; color: #878787">{{ orderItem.Batch&&orderItem.Batch.Product?orderItem.Batch.Product.name:'-'}}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <q-btn @click="removeGroupOneSelection(orderItem)" class="q-ml-auto" flat
                                               icon="close" round size="small"></q-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </q-card>
    </div>
</template>

<script>
    import {
        GET_ALL_ORGANIZATION,
        GET_ORDER_OF_DISTRIBUTOR,
        GET_ORDERITEMS_OF_ORDER,
        GET_PREFERRED_DISTRIBUTOR, GET_RETURN_ORDER_COUNT_OF_PARTNER,
    } from '../../graphql/queries/ReturnOrder'
    import moment from 'moment'
    import {INSERT_ORDER_AND_MULTIPLE_ORDER_ITEMS} from '../../graphql/mutations/products'

    export default {
        name: 'ReturnOrderRequest',
        props: ['currentPartner'],
        data() {
            return {
                user: JSON.parse(localStorage.getItem('user')),
                returnOrderCount: 0,
                partners: [], tempPartners: [], selectedPartner: null,
                preferredDistributors: [], tempPreferredDistributors: [], selectedPreferredDistributor: null,
                orders: [], tempOrders: [], selectedOrder: null,
                orderItems: [], tempOrderItems: [],
                modeOfReturn: [
                    {label: 'Whole Order', value: 'Whole Order'},
                    {label: 'Partial Order', value: 'Partial Order'}], selectedModeOfReturn: null,
                invoiceNumber: '', invoiceNote: '',
                invoiceDate: null,
                searchBatchObj: '',
                // selectAll: false,
                groupOneSelection: [], groupTwoSelection: [],
                isWholeOrderDisable: false,
                isPartnerDisable: false,
            }
        },
        apollo: {
            Organizations: {
                fetchPolicy: 'network-only',
                query: GET_ALL_ORGANIZATION,
                result({data, loading}) {
                    if (!loading) {
                        this.partners = data.Organizations
                        this.tempPartners = data.Organizations
                    }
                },
            },
            ReturnOrderCount: {
                fetchPolicy: 'network-only',
                query: GET_RETURN_ORDER_COUNT_OF_PARTNER,
                skip() {
                    return !this.selectedPartner
                },
                variables() {
                    return {from: this.selectedPartner.id,}
                },
                result({data, loading}) {
                    if (!loading) {
                        this.returnOrderCount = data.ReturnOrderCount.aggregate.count
                    }
                },
            },
            PrefferedDistributors: {
                fetchPolicy: 'network-only',
                query: GET_PREFERRED_DISTRIBUTOR,
                skip() {
                    return !this.selectedPartner
                },
                variables() {
                    return {
                        partnerId: this.selectedPartner.id,
                    }
                },
                result({data, loading}) {
                    if (!loading) {
                        let self = this
                        this.preferredDistributors = []
                        this.tempPreferredDistributors = []
                        data.PrefferedDistributors.forEach(distributor => {
                            if (distributor.PrefferedPartner) {
                                self.preferredDistributors.push(distributor)
                                self.tempPreferredDistributors.push(distributor)
                            }
                        })
                    }
                },
            },
            Orders: {
                fetchPolicy: 'network-only',
                query: GET_ORDER_OF_DISTRIBUTOR,
                skip() {
                    return !(this.selectedPreferredDistributor && this.selectedPreferredDistributor.PrefferedPartner &&
                        this.selectedPartner)
                },
                variables() {
                    return {
                        from: this.selectedPreferredDistributor.PrefferedPartner.id,
                        to: this.selectedPartner.id,
                    }
                },
                result({data, loading}) {
                    if (!loading) {
                        data.Orders.forEach(order => {
                            order['disabled'] = moment().format() >= moment(order.createdOn).add(60, 'days').format()
                        })
                        this.orders = data.Orders
                        this.tempOrders = data.Orders
                    }
                },
            },
            OrderItems: {
                fetchPolicy: 'network-only',
                query: GET_ORDERITEMS_OF_ORDER,
                skip() {
                    return !this.selectedOrder
                },
                variables() {
                    return {orderId: this.selectedOrder.id}
                },
                result({data, loading}) {
                    if (!loading) {
                        let self = this
                        this.orderItems = data.OrderItems
                        this.tempOrderItems = data.OrderItems
                        this.checkDisableWholeOrder()
                    }
                },
            },
        },
        methods: {
            searchPartners(val, update, abort) {
                if (val === '') {
                    update(() => {
                        this.partners = JSON.parse(JSON.stringify(this.tempPartners))
                    })
                    return
                }
                update(() => {
                    const needle = val.toLowerCase()
                    this.partners = this.tempPartners.filter(
                        v => ((v.mobile && v.mobile.toLowerCase().indexOf(needle) > -1) ||
                            (v.name && v.name.toLowerCase().indexOf(needle) > -1)))
                })
            },
            searchPreferredDistributors(val, update, abort) {
                if (val === '') {
                    update(() => {
                        this.preferredDistributors = JSON.parse(JSON.stringify(this.tempPreferredDistributors))
                    })
                    return
                }
                update(() => {
                    const needle = val.toLowerCase()
                    this.preferredDistributors = this.tempPreferredDistributors.filter(
                        v => ((v.PrefferedPartner && v.PrefferedPartner.mobile.toLowerCase().indexOf(needle) > -1) ||
                            (v.PrefferedPartner && v.PrefferedPartner.name.toLowerCase().indexOf(needle) > -1)))
                })
            },
            searchOrders(val, update, abort) {
                if (val === '') {
                    update(() => {
                        this.orders = JSON.parse(JSON.stringify(this.tempOrders))
                    })
                    return
                }
                update(() => {
                    const needle = val.toLowerCase()
                    this.orders = this.tempOrders.filter(
                        v => ((v.orderNum && v.orderNum.toLowerCase().indexOf(needle) > -1)))
                })
            },
            searchBatch(val) {
                if (val === '') {
                    this.orderItems = JSON.parse(JSON.stringify(this.tempOrderItems))
                } else {
                    const needle = val.toLowerCase()
                    this.orderItems = this.tempOrderItems.filter(
                        v => ((v.Batch && v.Batch.batch && v.Batch.batch.toLowerCase().indexOf(needle) > -1)))
                }
            },
            onReturnOrder() {
                let orderBatches
                if (this.selectedModeOfReturn === 'Whole Order') {
                    this.confirmReturnOrder(this.tempOrderItems)
                } else if (this.selectedModeOfReturn === 'Partial Order') {
                    orderBatches = this.groupTwoSelection ? this.groupTwoSelection.length : 0
                    this.confirmReturnOrder(this.groupTwoSelection)
                }
            },
            confirmReturnOrder(batches) {
                let self = this
                this.$q.dialog({
                    title: 'Confirm', message: 'Are you sure? ',
                    cancel: true, persistent: false,
                }).onOk(() => {
                    self.insertReturnOrder(batches)
                }).onCancel(() => {
                })
            },
            async insertReturnOrder(batches) {
                let self = this
                let orderItemArr = []
                let toOrgId = this.selectedPreferredDistributor.PrefferedPartner.id
                let fromOrgId = this.selectedPartner.id
                batches.forEach(batch => {
                    let obj = {
                        id: self.generateUUID(),
                        qty: batches.length,
                        from: fromOrgId,
                        to: toOrgId,
                        sellType: '3',
                        batchId: batch.Batch.id,
                        productInventoryId: null,
                        productId: batch.Batch && batch.Batch.Product ? batch.Batch.Product.id : '',
                        schemePoints: batch.schemePoints,
                        status: 'Pending',
                    }
                    orderItemArr.push(obj)
                })
                let orderTransferRequest = {
                    id: self.generateUUID(),
                    date: moment().format(),
                    from: fromOrgId,
                    to: toOrgId,
                    lineItemCounts: batches.length,
                    status: 'Pending',
                    placedBy: this.user.id,
                    invoiceNumber: self.invoiceNumber,
                    invoiceNote: self.invoiceNote,
                    invoiceDate: self.invoiceDate ? moment(self.invoiceDate).format('YYYY-MM-DD') : null,
                    orderType: 3,
                    referenceOrderId: self.selectedOrder.id,
                    OrderItems: {data: orderItemArr.length ? orderItemArr : null},
                }
                let response = await this.$apollo.mutate({
                    mutation: INSERT_ORDER_AND_MULTIPLE_ORDER_ITEMS,
                    variables: {orderObj: orderTransferRequest},
                })
                if (response.data) {
                    this.groupOneSelection = []
                    this.groupTwoSelection = []
                    this.$q.notify('Order Return Request Successfully')
                    this.closeReturnOrderDialog()
                }
            },
            checkDisableBatch(orderItem) {
                let temp = orderItem.Batch
                if (temp.status === 'InStock' && temp.ownedBy === this.selectedPartner.id && !temp.isOpened && !orderItem.isReturned) {
                    return {isDisabled: false, message: null}
                } else if (orderItem.isReturned) {
                    return {isDisabled: true, message: 'Batch is Returned'}
                } else {
                    return {isDisabled: true, message: 'Batch is Transferred'}
                }
            },
            checkDisableWholeOrder() {
                let self = this
                let disableArr = []
                this.orderItems.forEach(orderItem => {
                    disableArr.push(self.checkDisableBatch(orderItem))
                })
                this.isWholeOrderDisable = !!disableArr.filter(obj => obj.isDisabled).length
            },
            cleanObjects(objectValue, objectName) {
                let objToCleanPartner = ['preferredDistributors', 'tempPreferredDistributors']
                let objToCleanDistributor = ['orders', 'tempOrders']
                let commonObjToClean = ['orderItems', 'tempOrderItems', 'groupOneSelection', 'groupTwoSelection']
                if (objectName === 'selectedPartner') {
                    for (let obj of objToCleanPartner) {
                        this[obj] = []
                    }
                    for (let obj of objToCleanDistributor) {
                        this[obj] = []
                    }
                    for (let obj of commonObjToClean) {
                        this[obj] = []
                    }
                    this.selectedPreferredDistributor = null
                    this.selectedOrder = null
                } else if (objectName === 'selectedPreferredDistributor') {
                    for (let obj of objToCleanDistributor) {
                        this[obj] = []
                    }
                    for (let obj of commonObjToClean) {
                        this[obj] = []
                    }
                    this.selectedOrder = null
                } else if (objectName === 'selectedOrder') {
                    for (let obj of commonObjToClean) {
                        this[obj] = []
                    }
                }
            },
            addToCart() {
                this.groupTwoSelection = this.groupOneSelection
            },
            removeGroupOneSelection(batch) {
                var index = this.groupOneSelection.findIndex(function (item) {
                    return item.id === batch.id
                })
                if (index > -1)
                    this.groupOneSelection.splice(index, 1)
            },
            optionLabelPreferredDistributors(val) {
                if (val && val.PrefferedPartner)
                    return val.PrefferedPartner.name
            },
            closeReturnOrderDialog() {
                this.$emit('closeReturnOrderDialog')
            },
            generateUUID() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
                    return v.toString(16)
                })
            },
        },
        computed: {
            invoiceDateComp: {
                get: function () {
                    return moment(this.invoiceDate).format('DD/MM/YYYY')
                },
                set: function (newValue) {
                    if (!newValue) {
                        this.invoiceDate = null
                    }
                },
            },
        },
        watch: {
            invoiceDate(val) {
                this.invoiceDateComp = moment(val).format('DD/MM/YYYY')
            },
            // selectAll () {
            //   if (this.selectAll) {
            //     this.groupOneSelection = []
            //     this.orderItems.forEach(batch => {
            //       this.groupOneSelection.push(batch)
            //     })
            //   } else {
            //     this.groupOneSelection = []
            //   }
            // },
        },
        mounted() {
            if (this.currentPartner) {
                this.isPartnerDisable = true
                this.partners.push(this.currentPartner)
                this.tempPartners.push(this.currentPartner)
                this.selectedPartner = {'id': this.currentPartner.orgId, 'name': this.currentPartner.name}
            }
        },
    }
</script>

<style scoped>
    .card {
        text-align: center;
        width: 100%;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
    }
</style>
